export var getTextColor = function getTextColor(_ref) {
  var type = _ref.type,
    isClickable = _ref.isClickable,
    selected = _ref.selected,
    transitionTime = _ref.transitionTime;
  if (type === 'description') {
    if (isClickable && selected) {
      return 'textIconElementPrimary';
    }
    return 'textIconElementTertiary';
  }
  if (type === 'title') {
    if (isClickable && !selected) {
      return 'textIconElementSecondary';
    }
    return 'textIconElementPrimary';
  }
  if (type === 'number') {
    if (isClickable && !selected) {
      return 'textIconElementSecondary';
    }
    if (isClickable && selected && !transitionTime) {
      return 'textIconElementPrimaryInvert';
    }
    return 'textIconElementPrimary';
  }
  return 'textIconElementPrimary';
};